// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import { accordion } from 'utils/accordion';

/**
 * Component for FAQ block on front end.
 */
export default class Faq extends Component {
  constructor(config) {
    super(config);
    accordion('.faq__item', '.faq__question', 0, 0);
  }
}
